/* ============================================================
   KYRO PDP — gallery enhancements
   Loads after kyro-pdp.js and takes over the gallery.

   Fixes:
   1. Thumbnails are rebuilt from the slides, so every image gets one.
      main-kyro-pdp.liquid renders at most 5, which hid any extras.
   2. Swipe on the stage, so the overlay arrows can be hidden on phones.
   3. Tap or click any image to open a full-screen viewer with pinch,
      double-tap zoom and drag to pan.
   4. A counter pill, and a fade on the thumbnail strip when it scrolls.

   This replaces the prev/next and thumbnail handlers kyro-pdp.js binds,
   by cloning those nodes first. One set of handlers, one index.
   ============================================================ */
(function () {
  'use strict';

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  var ICON = {
    close: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    left: '<polyline points="15 18 9 12 15 6"/>',
    right: '<polyline points="9 18 15 12 9 6"/>'
  };
  function svg(name) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" ' +
      'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' + ICON[name] + '</svg>';
  }

  /* Best available source for a slide: the rendered srcset candidate if the
     browser has already picked one, otherwise the plain src. */
  function slideSrc(slide) {
    var img = slide.querySelector('img');
    if (img) return img.currentSrc || img.src || '';
    var video = slide.querySelector('video');
    if (video) return video.getAttribute('poster') || '';
    return '';
  }

  function isVideoSlide(slide) {
    return !!slide.querySelector('video, iframe');
  }

  function init(root) {
    var gallery = root.querySelector('.gallery');
    var stage = root.querySelector('.gallery-stage');
    if (!gallery || !stage) return;

    var slides = $all('[data-slide]', stage);
    if (!slides.length) return;

    /* ---------- Thumbnails, rebuilt from the slides ---------- */
    var thumbs = gallery.querySelector('.thumbs');
    if (!thumbs && slides.length > 1) {
      thumbs = document.createElement('div');
      thumbs.className = 'thumbs';
      gallery.appendChild(thumbs);
    }
    if (thumbs) {
      thumbs.innerHTML = '';
      slides.forEach(function (slide, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'thumb';
        btn.setAttribute('data-thumb', String(i));
        btn.setAttribute('aria-label', 'View image ' + (i + 1));
        var src = slideSrc(slide);
        if (src) {
          btn.innerHTML = '<img src="' + src + '" alt="" loading="lazy" width="200" height="200">';
        }
        if (isVideoSlide(slide)) btn.classList.add('kg-thumb-video');
        thumbs.appendChild(btn);
      });
      if (slides.length < 2) thumbs.style.display = 'none';
    }

    /* ---------- Counter ---------- */
    var counter = document.createElement('div');
    counter.className = 'kg-counter';
    stage.appendChild(counter);

    /* ---------- Take the arrows off kyro-pdp.js ----------
       Cloning a node drops its event listeners, so the old handler and its
       stale index stop fighting with ours. */
    function reclaim(el) {
      if (!el) return null;
      var clone = el.cloneNode(true);
      el.parentNode.replaceChild(clone, el);
      return clone;
    }
    var prevBtn = reclaim(stage.querySelector('[data-gallery-prev]'));
    var nextBtn = reclaim(stage.querySelector('[data-gallery-next]'));

    var idx = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('active')) idx = i; });

    function scrollThumbIntoView(btn) {
      if (!thumbs || !btn) return;
      var left = btn.offsetLeft;
      var right = left + btn.offsetWidth;
      var viewL = thumbs.scrollLeft;
      var viewR = viewL + thumbs.clientWidth;
      if (left < viewL) thumbs.scrollLeft = left - 8;
      else if (right > viewR) thumbs.scrollLeft = right - thumbs.clientWidth + 8;
    }

    function show(i) {
      idx = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === idx); });
      if (thumbs) {
        $all('.thumb', thumbs).forEach(function (t, k) {
          var on = k === idx;
          t.classList.toggle('active', on);
          if (on) scrollThumbIntoView(t);
        });
      }
      counter.textContent = (idx + 1) + ' / ' + slides.length;
      if (lb.classList.contains('open')) paintLightbox();
      updateThumbFade();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });

    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb]');
        if (!btn || !thumbs.contains(btn)) return;
        show(parseInt(btn.getAttribute('data-thumb'), 10) || 0);
      });
    }

    /* ---------- Fade the thumb strip when there is more to scroll ---------- */
    function updateThumbFade() {
      if (!thumbs) return;
      var max = thumbs.scrollWidth - thumbs.clientWidth;
      if (max < 4) {
        thumbs.classList.remove('kg-more-left', 'kg-more-right');
        return;
      }
      thumbs.classList.toggle('kg-more-left', thumbs.scrollLeft > 4);
      thumbs.classList.toggle('kg-more-right', thumbs.scrollLeft < max - 4);
    }
    if (thumbs) {
      thumbs.addEventListener('scroll', updateThumbFade, { passive: true });
      window.addEventListener('resize', updateThumbFade);
    }

    /* ---------- Swipe the stage ---------- */
    var sx = 0, sy = 0, swiping = false, moved = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swiping = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      swiping = true;
      moved = false;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!swiping || e.touches.length !== 1) return;
      if (Math.abs(e.touches[0].clientX - sx) > 8) moved = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        show(dx < 0 ? idx + 1 : idx - 1);
        moved = true;
      }
    }, { passive: true });

    /* ---------- Open the viewer ---------- */
    stage.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) return;
      if (moved) { moved = false; return; }
      if (isVideoSlide(slides[idx])) return;
      openLightbox();
    });

    /* ============================================================
       Full-screen viewer
       ============================================================ */
    var lb = document.createElement('div');
    lb.className = 'kg-lightbox';
    lb.innerHTML =
      '<div class="kg-lb-stage"><img class="kg-lb-img" alt=""></div>' +
      '<button type="button" class="kg-lb-btn kg-lb-close" aria-label="Close">' + svg('close') + '</button>' +
      '<button type="button" class="kg-lb-btn kg-lb-prev" aria-label="Previous image">' + svg('left') + '</button>' +
      '<button type="button" class="kg-lb-btn kg-lb-next" aria-label="Next image">' + svg('right') + '</button>' +
      '<div class="kg-lb-counter"></div>';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('.kg-lb-img');
    var lbCount = lb.querySelector('.kg-lb-counter');
    var scale = 1, tx = 0, ty = 0;

    function applyTransform() {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      lb.classList.toggle('kg-zoomed', scale > 1.02);
    }
    function resetZoom() { scale = 1; tx = 0; ty = 0; applyTransform(); }

    function paintLightbox() {
      lbImg.src = slideSrc(slides[idx]);
      lbCount.textContent = (idx + 1) + ' / ' + slides.length;
      resetZoom();
    }

    function openLightbox() {
      paintLightbox();
      lb.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lb.classList.remove('open');
      document.documentElement.style.overflow = '';
      resetZoom();
    }

    lb.querySelector('.kg-lb-close').addEventListener('click', closeLightbox);
    lb.querySelector('.kg-lb-prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.kg-lb-next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('kg-lb-stage')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });

    /* ---- Double click / double tap toggles zoom ---- */
    var lastTap = 0;
    function toggleZoom(clientX, clientY) {
      if (scale > 1.02) { resetZoom(); return; }
      scale = 2.5;
      var r = lbImg.getBoundingClientRect();
      var cx = clientX - (r.left + r.width / 2);
      var cy = clientY - (r.top + r.height / 2);
      tx = -cx * (scale - 1);
      ty = -cy * (scale - 1);
      clampPan();
      applyTransform();
    }
    lbImg.addEventListener('dblclick', function (e) {
      e.preventDefault();
      toggleZoom(e.clientX, e.clientY);
    });

    function clampPan() {
      var r = lbImg.getBoundingClientRect();
      var w = r.width / scale, h = r.height / scale;
      var maxX = Math.max(0, (w * scale - window.innerWidth) / 2);
      var maxY = Math.max(0, (h * scale - window.innerHeight) / 2);
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }

    /* ---- Touch: pinch to zoom, drag to pan, swipe to change ---- */
    var pStartDist = 0, pStartScale = 1;
    var dragX = 0, dragY = 0, dragTx = 0, dragTy = 0, dragging = false;
    var lbSwipeX = 0, lbSwipeMoved = false;

    function dist(t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.hypot(dx, dy);
    }

    lbImg.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pStartDist = dist(e.touches);
        pStartScale = scale;
        dragging = false;
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) toggleZoom(e.touches[0].clientX, e.touches[0].clientY);
        lastTap = now;

        dragging = scale > 1.02;
        dragX = e.touches[0].clientX;
        dragY = e.touches[0].clientY;
        dragTx = tx;
        dragTy = ty;
        lbSwipeX = e.touches[0].clientX;
        lbSwipeMoved = false;
      }
    }, { passive: true });

    lbImg.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var d = dist(e.touches);
        if (pStartDist > 0) {
          scale = Math.max(1, Math.min(5, pStartScale * (d / pStartDist)));
          clampPan();
          applyTransform();
        }
      } else if (e.touches.length === 1 && dragging) {
        e.preventDefault();
        tx = dragTx + (e.touches[0].clientX - dragX);
        ty = dragTy + (e.touches[0].clientY - dragY);
        clampPan();
        applyTransform();
      } else if (e.touches.length === 1) {
        if (Math.abs(e.touches[0].clientX - lbSwipeX) > 10) lbSwipeMoved = true;
      }
    }, { passive: false });

    lbImg.addEventListener('touchend', function (e) {
      if (scale <= 1.02 && lbSwipeMoved && e.changedTouches.length) {
        var dx = e.changedTouches[0].clientX - lbSwipeX;
        if (Math.abs(dx) > 55) show(dx < 0 ? idx + 1 : idx - 1);
      }
      if (scale <= 1.02) resetZoom();
      dragging = false;
      pStartDist = 0;
    }, { passive: true });

    /* ---- Mouse drag to pan when zoomed ---- */
    lbImg.addEventListener('mousedown', function (e) {
      if (scale <= 1.02) return;
      e.preventDefault();
      dragging = true;
      dragX = e.clientX; dragY = e.clientY; dragTx = tx; dragTy = ty;
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      tx = dragTx + (e.clientX - dragX);
      ty = dragTy + (e.clientY - dragY);
      clampPan();
      applyTransform();
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    /* ---------- Keep in step with variant image swaps ---------- */
    document.addEventListener('kyro:variant:change', function () {
      if (thumbs) {
        var first = thumbs.querySelector('.thumb img');
        var heroSrc = slideSrc(slides[0]);
        if (first && heroSrc) first.src = heroSrc;
      }
    });

    show(idx);
    updateThumbFade();
  }

  function boot() {
    $all('.kyro-pdp[data-pdp-root]').forEach(function (root) {
      if (root.dataset.kgDone) return;
      root.dataset.kgDone = '1';
      try { init(root); }
      catch (e) { console.warn('KYRO gallery: init failed', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
